export interface TTSProvider {
  speak(text: string): Promise<void>;
  stop(): void;
  isSpeaking(): boolean;
  /** Lower volume to ~15% so user speech is audible over TTS */
  duck(): void;
  /** Restore volume to 100% */
  unduck(): void;
  /** Release audio resources */
  dispose(): void;
  /** Warm up audio context before speak() is called */
  prepare(): Promise<void>;
  onStart?: () => void;
  onEnd?: () => void;
}

export interface QueueItem {
  text: string;
  status: 'pending' | 'fetching' | 'ready' | 'playing' | 'done';
  buffer: AudioBuffer | undefined;
  abort: AbortController | undefined;
}

export const MAX_PREFETCH = 2;
export const PER_REQUEST_TIMEOUT_MS = 15_000;
